module.exports = __webpack_public_path__ + "static/img/Group_2182.c5d49220.png";